import { useAuthStore } from '../auth-store.js'
import { useRouter } from '../router-store.js'
import { useThemeStore } from '../theme-store.js'
import { Button } from './Button.js'
import { IconButton } from './IconButton.js'
import { ChevronLeftIcon, MoonIcon, SunIcon } from './icons.js'
import { LogoMark } from './LogoMark.js'

interface AppNavProps {
  breadcrumb?: string
}

export function AppNav({ breadcrumb }: AppNavProps) {
  const { logout } = useAuthStore()
  const { navigateToOverview } = useRouter()
  const { theme, toggle: toggleTheme } = useThemeStore()

  const logo = (
    <div className="w-7 h-7 rounded-lg bg-brand-gradient-hero flex items-center justify-center shadow-brand shrink-0">
      <LogoMark size={14} />
    </div>
  )

  return (
    <nav className="sticky top-0 z-10 bg-brand-surface/80 backdrop-blur border-b border-brand-border">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          {breadcrumb ? (
            <>
              <button
                onClick={navigateToOverview}
                aria-label="Back to overview"
                className="flex items-center gap-1.5 text-brand-text-muted hover:text-brand-text transition-colors shrink-0"
              >
                <ChevronLeftIcon className="w-4 h-4" />
                {logo}
                <span className="hidden sm:inline font-semibold text-sm">
                  IELTS Buddy
                </span>
              </button>
              <span className="text-brand-text-subtle text-sm shrink-0">/</span>
              <span className="font-semibold text-brand-text text-sm truncate">
                {breadcrumb}
              </span>
            </>
          ) : (
            <>
              {logo}
              <span className="font-semibold text-brand-text text-sm">
                IELTS Buddy
              </span>
            </>
          )}
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <IconButton onClick={toggleTheme} aria-label="Toggle theme">
            {theme === 'dark' ? (
              <SunIcon className="w-4 h-4" />
            ) : (
              <MoonIcon className="w-4 h-4" />
            )}
          </IconButton>
          <Button variant="subtle" size="sm" onClick={logout}>
            Log out
          </Button>
        </div>
      </div>
    </nav>
  )
}
